import { render } from "./ArtikelInfoPendaftaran.vue?vue&type=template&id=6bb46445"
import script from "./ArtikelInfoPendaftaran.vue?vue&type=script&lang=js"
export * from "./ArtikelInfoPendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__